import React from "react";
import DashboardBarChart from "../../common/DashboardBarChart";
import { GENDER_COLORS } from "../../../utils/chartTheme";

const GenderSection = ({ currentData }) => {
  // Extract male, female, and transgender counts
  const maleValue =
    currentData?.genderData?.find(
      (item) => item.name.toLowerCase() === "male"
    )?.value || 0;

  const femaleValue =
    currentData?.genderData?.find(
      (item) => item.name.toLowerCase() === "female"
    )?.value || 0;

  const transgenderValue =
    currentData?.genderData?.find(
      (item) => item.name.toLowerCase() === "transgender"
    )?.value || 0;

  return (
    <div>
      <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-center text-balance">Gender Segregated</h3>
      <DashboardBarChart
        items={[
          { name: "Male", count: maleValue, color: GENDER_COLORS.male },
          { name: "Female", count: femaleValue, color: GENDER_COLORS.female },
          { name: "Transgender", count: transgenderValue, color: GENDER_COLORS.other },
        ]}
        unit="applicants"
      />
    </div>
  );
};

 export default GenderSection;
